import { getStorage, setStorage } from '@/storage';
import { timeInSeconds } from '@/utils';
import { getDiffInDays } from './utils';

function initialState(rule = {}) {
	const prevState = getStorage(rule.id);

	return {
		conditions: rule.if.map(condition => {
			return {
				triggered: false,
				formEvents: {},
				domEvents: {},
			};
		}),
		...prevState,
	};
}

function initialValidState(rule = {}) {
	return {
		conditions: rule.if.map(() => {
			return false;
		}),
	};
}

function initialZeroDayState(rule = {}) {
	return {
		conditions: rule.if.map(() => {
			return {
				triggered: false,
				formEvents: {},
			};
		}),
	};
}

function initialEventListenerState(rule) {
	return {
		conditions: rule.if.map(condition => {
			return {
				domEvents: {},
			};
		}),
	};
}

export default function createRuleStore(rule) {
	const state = initialState(rule);
	//keep this separate -> we don't want to save this in localStorage
	const validState = initialValidState(rule);
	//zero day state is for conditions that have a 0 day session, only keep state for current initialisation
	const zeroDayState = initialZeroDayState(rule);
	const timeOnPageState = {};
	const eventListenerState = initialEventListenerState(rule);

	console.log({ eventListenerState });

	function setState(fn = () => {}) {
		const newState = fn(state);
		if (newState) {
			Object.assign(state, newState);
		}
		setStorage(rule.id, state);
	}

	function setConditionState(index, fn) {
		const sessionDays = Number(rule.if[index]?.session);
		if (sessionDays === 0) {
			return fn(zeroDayState.conditions[index]);
		}

		setState(state => {
			//set timestamp on session update if none present
			try {
				if (!state.conditions[index].timestamp) {
					state.conditions[index].timestamp = new Date();
				}
				fn(state.conditions[index]);
			} catch (e) {}
		});
	}

	function getState(fn = () => {}) {
		return fn(state);
	}

	//check session if session expired if so clear condition state
	function handleSession(index) {
		const sessionDays = rule.if[index]?.session;
		const timestamp = state.conditions?.[index]?.timestamp;

		if (typeof sessionDays !== 'undefined' && typeof timestamp !== 'undefined') {
			const daysSinceTimestamp = getDiffInDays(timestamp);
			if (daysSinceTimestamp >= Number(sessionDays)) {
				console.log(`rule ${rule.id}, condition ${index}, session expired`);
				setConditionState(index, conditionState => {
					Object.keys(conditionState).forEach(key => {
						delete conditionState[key];
					});
				});
			}
		}
	}

	function getConditionState(index, fn = () => {}) {
		const sessionDays = Number(rule.if[index]?.session);
		if (sessionDays === 0) {
			return fn(zeroDayState.conditions?.[index] ?? {});
		}

		handleSession(index);
		return fn(state.conditions?.[index] ?? {});
	}

	function setValidState(index, valid) {
		try {
			validState.conditions[index] = valid;
		} catch (e) {}
	}

	function getValidState(index) {
		return validState.conditions?.[index] ?? false;
	}

	function getValidConditions() {
		const conditions = [];
		for (let i = 0; i < validState.conditions.length; i++) {
			const valid = validState.conditions[i];
			if (valid) {
				conditions.push({
					condition: rule.if?.[i],
					index: i,
				});
			}
		}
		return conditions;
	}

	function setTimeOnPageState(index, type = 'time') {
		try {
			if (!timeOnPageState[index]) {
				timeOnPageState[index] = {};
			}
			timeOnPageState[index][type] = timeInSeconds();
		} catch (e) {}
	}
	function getTimeOnPageState(index, type = 'time') {
		return timeOnPageState[index]?.[type];
	}

	return {
		setState,
		setConditionState,
		getState,
		getConditionState,
		setValidState,
		getValidState,
		getValidConditions,
		setTimeOnPageState,
		getTimeOnPageState,
	};
}
